import { useParams } from "react-router-dom";
import AdminRentalBuilder from "./builder/AdminRentalBuilder";

const RentalEdit = () => {
  const { id } = useParams();

  return (
    <AdminRentalBuilder
      open
      rentalId={id}
      showApprovalActions
      exitPath="/rentals"
    />
  );
};

export default RentalEdit;
